export default "__VITE_ASSET__C4Pojk$h__"